import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";

const SpeakerField = ({ onChange, speakers, setSpeakers }) => {
  const textAreaRef = useRef(null);
  const handleInputChange = (index, value) => {
    const newSpeakers = [...speakers];
    newSpeakers[index] = value;
    setSpeakers(newSpeakers);
    onChange("speakers", newSpeakers);
  };

  const [showTextbox, setShowTextbox] = useState(false);
  const [bulkImport, setBulkImport] = useState("");

  const addNewSpeaker = () => {
    setSpeakers((prevSpeakers) => [...prevSpeakers, ""]);
  };

  const handleShowBulkImport = () => {
    setShowTextbox(true);
  };

  const handleSubmitBulkImport = () => {
    const bulkImportSpeakers = bulkImport.split("\n").map(speaker => speaker.trim());
    const filteredBulkImportSpeakers = bulkImportSpeakers.filter(speaker => speaker !== "");
    const filteredSpeakers = speakers.filter(speaker => speaker !== "");
    const mergedSpeakers = [...filteredSpeakers, ...filteredBulkImportSpeakers];
    const uniqueSpeakers = [...new Set(mergedSpeakers)];
    setSpeakers(uniqueSpeakers);
    onChange("speakers", uniqueSpeakers);
    setShowTextbox(false);
  };

  useEffect(() => {
    // on click outside of the text area, close the text area if it is open and empty
    const handleClickOutside = (event) => {
      if (showTextbox && textAreaRef.current && !textAreaRef.current.contains(event.target)) {
        if (bulkImport.length === 0) {
          setShowTextbox(false);
          setBulkImport("");
        } else {
          // alert with confirmation
          const confirm = window.confirm("Are you sure you want to close the bulk import?");
          if (confirm) {
            setShowTextbox(false);
            setBulkImport("");
          }
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTextbox, bulkImport]);

  return (
    <div className={styles.speakerInputs} ref={textAreaRef}>
      {speakers.map((speaker, index) => (
        <div className={styles.speakerWrapper} key={index}>
          <input
            placeholder="Speaker"
            type="text"
            value={speaker}
            onChange={(e) => handleInputChange(index, e.target.value)}
          />
          {index > 0 && (
            <button
              type="button"
              className={styles.removeIcon}
              onClick={() => {
                const newSpeakers = [...speakers];
                newSpeakers.splice(index, 1);
                setSpeakers(newSpeakers);
                onChange("speakers", newSpeakers);
              }}
            >
              <img
                src={"/icons/remove.svg"}
                width={20}
                alt="Remove speaker"
              />
            </button>
          )}
        </div>
      ))}
      {showTextbox && (
        <div className={styles.bulkImportContainer}>
          <textarea name="bulkImport" id="bulkImport" placeholder="Bulk Import Speakers: One per line!" rows={10} onChange={(e) => setBulkImport(e.target.value)}></textarea>
        </div>
      )}
      <div className={styles.importContainer}>
        {showTextbox && (
          <button type="button" onClick={handleSubmitBulkImport}>
            <span>Submit</span>
            <div>
              <img src={"/icons/plus-color.svg"} width={14} alt="Add more URLs" />
            </div>
          </button>
        )}
        {!showTextbox && (
          <button type="button" onClick={handleShowBulkImport}>
            <span>Bulk Import</span>
            <div>
              <img src={"/icons/plus-color.svg"} width={14} alt="Add more URLs" />
            </div>
          </button>
        )}
        {!showTextbox && (
          <button type="button" onClick={addNewSpeaker}>
            <span>Add more speakers</span>
            <div>
              <img src={"/icons/plus-color.svg"} width={14} alt="Add more URLs" />
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default SpeakerField;
